import { Tabs, TabsProps } from 'antd';

import styles from './tab.module.scss';
import clsx from 'clsx';

interface TabProps {
  items: {
    key: string;
    label: string;
    children: JSX.Element;
    disabled?: boolean;
  }[];
  className?: string;
}

export const Tab = ({ items, className }: TabProps) => {
  const tabItems: TabsProps['items'] = items.map((item) => ({
    key: item.key,
    label: item.label,
    children: item.children,
    disabled: item.disabled,
  }));

  return <Tabs items={tabItems} className={clsx(styles.tabs, className)} />;
};
